import React from 'react'
import {
    Show,
    SimpleShowLayout,
    TextField,
    BooleanField,
    ReferenceField,
} from 'react-admin'


export const DatoTecnicoShow = props => (
    <Show {...props}>
        <SimpleShowLayout>
            <TextField source="name" />
            <TextField source="description" />
            <BooleanField source="active" />
            <ReferenceField source="datasheet_type" reference="esquemas-datos-tecnicos">
                <TextField source="name" />
            </ReferenceField>
        </SimpleShowLayout>
    </Show>
);
